import parse from 'date-fns/parse'

export function parseDate(date: string): Date {
  return parse(date, 'yyyy-MM-dd HH:mm', new Date())
}
